module.exports = __webpack_public_path__ + "static/media/newsImage2.62a27c4a.png";